import { Middleware, Dispatch } from 'redux';
import { getType, ActionType } from 'typesafe-actions';

import { DataState } from '../../../state';
import { RootAction } from '../../../actions';
import { ApiProvider } from '../../../../../context/Api';
import { AdminEntitlementsActions } from '../../../actions/admin/EntitlementsActions';
import { EntitlementsSearchRequest } from '@tradingblock/types';

const getEntitlementRequests = async (
  state: DataState,
  dispatch: Dispatch<RootAction>,
  action: ActionType<typeof AdminEntitlementsActions.requestEntitlementUpdates>
) => {
  const api = ApiProvider(state, dispatch);
  const { page, pageSize, blockId } = action.payload;

  if (api) {
    try {
      const response = await api.entitlements.getPendingUserMarketDataEntitlements({ page, pageSize });
      dispatch(AdminEntitlementsActions.receiveEntitlementUpdates({ response: response.payload, blockId }));
    } catch (err) {
      dispatch(AdminEntitlementsActions.errorEntitlementUpdates({ error: err, blockId }));
      console.error('getUserAccountDetails Error', err);
    }
  }
};

export const AdminEntitlementsMiddleware: Middleware<Dispatch<RootAction>, DataState, Dispatch<RootAction>> = ({
  dispatch,
  getState,
}) => (next: Dispatch<RootAction>) => (action: RootAction) => {
  try {
    const result = next(action);
    const nextState = getState();
    switch (action.type) {
      case getType(AdminEntitlementsActions.setEntitlementsPage): {
        const { blockId, page } = action.payload;
        const pageSize =
          nextState.private.entitlements.entitlementDataByBlockId &&
          nextState.private.entitlements.entitlementDataByBlockId[blockId] &&
          nextState.private.entitlements.entitlementDataByBlockId[blockId].pageSize;

        dispatch(
          AdminEntitlementsActions.requestEntitlementUpdates({
            ...({ page, pageSize } as EntitlementsSearchRequest),
            blockId,
          })
        );

        break;
      }
      case getType(AdminEntitlementsActions.refreshEntitlements): {
        const { blockId, page, pageSize } = action.payload;

        dispatch(
          AdminEntitlementsActions.requestEntitlementUpdates({
            ...({ page, pageSize } as EntitlementsSearchRequest),
            blockId,
          })
        );

        break;
      }
      case getType(AdminEntitlementsActions.setEntitlementsPageSize): {
        const { blockId, pageSize } = action.payload;
        const page =
          nextState.private.entitlements.entitlementDataByBlockId &&
          nextState.private.entitlements.entitlementDataByBlockId[blockId] &&
          nextState.private.entitlements.entitlementDataByBlockId[blockId].page;

        dispatch(
          AdminEntitlementsActions.requestEntitlementUpdates({
            ...({ page, pageSize } as EntitlementsSearchRequest),
            blockId,
          })
        );

        break;
      }
      case getType(AdminEntitlementsActions.requestEntitlementUpdates): {
        getEntitlementRequests(nextState, dispatch, action);
        break;
      }
    }
    return result;
  } catch (err) {
    console.error('AdminEntitlementsMiddleware Error', err);
  }
};
